//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: String | Object,
    label: {
      type: String,
      default: 'Upload a file or drag an drop'
    },
    icon: {
      type: String,
      default: 'add_photo_alternate'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    position: String,
  },
  data() {
    return {
      url: null,
      file: null,
    }
  },

  watch: {
    value(current, old) {
      console.log('Watch', current)
      if (current instanceof File) {
        this.selectedFile(current)
      } else if (typeof current === 'string') {
        this.url = current
      }
    }
  },

  mounted() {
    console.log('Mounted', this.value)
    if (typeof this.value === 'string') {
      this.url = this.value
    }
  },

  methods: {
    clickedInput(e) {
      this.createFile(e)
    },
    clickOnInput(e) {
      const uploadInput = document.getElementById('file-upload');
      uploadInput.click();
    },
    createFile(e) {
      const files = e.target.files || e.dataTransfer.files
      this.selectedFile(files.item(0))
    },
    selectedFile(file) {
      this.file = file
      this.url = URL.createObjectURL(file)
      this.$emit('input', file)
    },
    drop(e) {
      this.createFile(e)
    },
    dragover(e) {
      // Cambiamos el cursor a 'copy'
      e.dataTransfer.dropEffect = 'copy';
    },
    onInput(e) {
      this.$emit('input', e)
    }
  }
}
